import clsx from 'clsx';

import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CartLength from './CartLength';
import { addToCart, removeFromCart } from '../actions/cartActions';
import useAxios from '../axios/useAxios';
import paniervide from '../styles/img/paniervide.svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import {
  cartPrice,
  formatPriceWithEuro,
  truncate,
} from '../utils/StringUtils';
import moins_icon from '../styles/img/arrow/moins.svg';
import plus_icon from '../styles/img/arrow/plus.svg';
import { hasFidelityCard, isAllowedToPay, isStoreIntegrated, MINIMUM_PRICE } from '../utils/Validator';
import cartdelete from '../styles/img/cart_delete.svg';
import LoaderWithText from './loader/LoaderWithText';
import pikkocoin from '../styles/img/Pikkocoin.svg';
import CalculatePromoButton from './button/CalculatePromoButton';
import PromoAndPointsDisplay from './tile/PromoAndPointsDisplay';
import {
  ADD_FID_SCAN,
  CART, FIDCOUPON,
  INVITATION,
  PROMO,
  AMOUNT_CHANGE_JACKPOT,
} from '../constants/routes';
import { IoInformationCircleOutline, IoReload } from "react-icons/io5";
import { HiAdjustments } from "react-icons/hi";
import { BeatLoader } from 'react-spinners';
import { useJackpotMatch } from '../hooks/useJackpotMatch';
import { calculateTotalToPay } from '../utils/order/orderUtils';

const FooterCart = ({ scanPause, handleResetToaster, theme, currentProduct }, ref) => {
  const sheetRef = useRef(null);
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadingCart, cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const [showCart, setShowCart] = useState(false);
  const [localQty,] = useState([]);
  const [lastCallTimestamp, setLastCallTimestamp] = useState(0);
  const [lastCallTime, setLastCallTime] = useState(0);
  const [cartChange, setCartChange] = useState(false);

  const SNAP = 'SNAP';
  const DONTLOOP = 'Dont_loop';
  const countItems = CartLength();
  const isAllowedToPurchase = isAllowedToPay(cartItems);

  const disablePurchaseButton = () => {
    return countItems === 0 || !isAllowedToPurchase;
  };

  const addToCartHandler = (event, product) => {
    event.stopPropagation();
    dispatch(addToCart(cartItems._id, product, 1, axiosInstance));
    setCartChange(true);
  };

  async function removeFromCartHandler(event, product_qty) {
    event.stopPropagation();

    const cbarre_qty = product_qty.map(({ product, qty }) => ({
      Code_Barre: product.Code_Barre,
      qty: qty,
    }));

    dispatch(
      removeFromCart(cbarre_qty, cartItems._id, product_qty, axiosInstance),
    );
    setCartChange(true);
  }

  const onClickInfooter = () => {
    handleResetToaster();
    if (store && countItems >= store?.item_limit) {
      scanPause(true);
    } else {
      scanPause(!showCart);
    }

    setShowCart(!showCart);
    if (showCart) {
      sheetRef.current.snapTo(100, { source: DONTLOOP });
    } else {
      sheetRef.current.snapTo(1000, { source: DONTLOOP });
    }
  };

  const handleShowCart = () => {
    const now = Date.now();
    // Vérifie si moins de 500 millisecondes se sont écoulées depuis le dernier appel,c'est pour éviter les appels multiples
    if (now - lastCallTime < 500) {
      setLastCallTime(now); // Met à jour le temps du dernier appel de la fonction
      return;
    }
    if (showCart) {
      sheetRef.current.snapTo(100);
    } else {
      sheetRef.current.snapTo(1000);
    }
    setTimeout(() => {
      setShowCart(!showCart);
    }, 150);

    if (store && countItems < store?.item_limit) {
      // scanPause(!showCart);
    }
    // Met à jour le temps du dernier appel
    setLastCallTime(now);
  };

  useImperativeHandle(ref, () => ({
    onClickInfooter,
    handleShowCart,
  }));

  const onclickExterior = () => {
    setShowCart(false);

    if (store && countItems >= store?.item_limit) {
      scanPause(true);
    } else {
      scanPause(false);
    }
    sheetRef.current.snapTo(100, { source: DONTLOOP });
  };

  const toPay = (e) => {
    e.stopPropagation();

    if (!showCart) {
      setShowCart(true);
      sheetRef.current.snapTo(1000, { source: DONTLOOP });
      return;
    }
    navigate(CART);
  };
  const handleCartChange = () => {
    setCartChange(false);
  };
  const addFidCardButton = (e) => {
    e.stopPropagation();
    navigate(ADD_FID_SCAN);
  };

  // INIT Jackpot Match
  const {
    isJackpotMatchActive,
    isLoadingFidCards,
    errorMessageFidCards,
    jackpotMatchSolde,
    jackpotMatchAmount,
    isShouldShowFidMatch,
    handleJackpotMatch,
  } = useJackpotMatch({
    axiosInstance,
    user,
    cartItems,
    store,
    shouldFetch: showCart && store && store?.api !== 'mongoDb',
  });

  const isFidelityCardAdded = showCart && isShouldShowFidMatch && hasFidelityCard(user);
  const isFidelityCardNotAdded = showCart && isShouldShowFidMatch && !hasFidelityCard(user);

  const renderFidCardButtonAdded = () => {
    return (
      <button
        type="button"
        className="add-fid-card-button present"
        onClick={(e) => addFidCardButton(e)}
      >
        <div className="add-fid-card-button-first-name">
          <img src={store.logo} alt="logo" />
        </div>
        <div className="add-fid-name-container">
          {user.fidCard[0].fidelityInfo.ficheClient.nom}{' '}
          {user.fidCard[0].fidelityInfo.ficheClient.prenom}
          <div className="add-fid-card-button-change">Changer</div>
        </div>
      </button>
    );
  };

  const renderFidCardButtonNotAdded = () => {
    return (
      <button
        type="button"
        className="add-fid-card-button"
        onClick={(e) => addFidCardButton(e)}
      >
        + Ajouter ma carte de fidélité
      </button>
    );
  };

  const renderJackpotMatchInformation = () => {
    const isPromo = cartItems.promoPrice !== cartItems.itemsPrice;
    const maximumPrice = isPromo ? cartItems.promoPrice : cartItems.itemsPrice;
    const priceMaximumUsable = Math.min(Math.max(0, jackpotMatchSolde), maximumPrice);
    const amountToShow = isJackpotMatchActive ? jackpotMatchAmount : priceMaximumUsable;

    if (amountToShow === null || amountToShow === undefined) {
      return null;
    }

    return (
      <div className="flex items-center justify-start w-full">
        <div className="flex text-left mr-4 justify-start text-[1em] font-geomanistlight font-semibold">
          {formatPriceWithEuro(amountToShow)}
        </div>

      {isJackpotMatchActive ?
        <div className="flex items-center justify-center">
          <HiAdjustments size={20} onClick={() => navigate(AMOUNT_CHANGE_JACKPOT)} />
        </div>
        : null}
      </div>
    );
  };

  const renderJackpotMatchContent = () => {
    if (errorMessageFidCards) {
      return (
        <div className="flex items-center justify-center w-full">
          <p className="text-red-500">{errorMessageFidCards}</p>
          <button type="button" className="flex flex-1 justify-end"
                  onClick={(event) => handleJackpotMatch(event)}>
            <IoReload size={20} /> Recharger
          </button>
        </div>
      );
    }

    if (isLoadingFidCards) return (
      <div className="flex items-end justify-center w-full">
        <BeatLoader color="#666" size={20} />
      </div>
    );

    const { nom, prenom } = user.fidCard[0].fidelityInfo.ficheClient;

    return (
      <>
        <div className="flex items-start justify-center max-w-[60px]">
          <img className="w-full h-full object-contain" src={store.logo} alt="logo" />
        </div>

        <div className="flex gap-2 items-start justify-center flex-col">
          <span className="text-left font-geomanistbold">{nom}{' '}{prenom}</span>

          {renderJackpotMatchInformation()}
        </div>

        <button
          type="button"
          className="flex flex-1 justify-end"
          onClick={(event) => handleJackpotMatch(event)}
        >
          {isJackpotMatchActive ? 'Fermer' : 'Activer'}
        </button>
      </>
    );
  };

  const renderJackpotMatch = () => {
    if (!user?.fidCard?.[0]?.fidelityInfo?.ficheClient) {
      console.error('Fidélité Match: Fidélité card not found');
      return null;
    };

    return (
      <div className={clsx(
          "flex fixed bottom-[80px] justify-left items-center",
          "rounded-[0.6em] text-gray-500 border border-solid",
          "w-[90%] gap-4 px-4 py-3 text-[1.4em] overflow-hidden font-geomanistmedium",
          {
            "border-gray-300 bg-gray-200": !isJackpotMatchActive,
            "p-3 border-solid border-[1.5px] bg-[#A0FFDC] border-[#5BB996]": isJackpotMatchActive,
          }
        )}>
        {renderJackpotMatchContent()}
      </div>
    );
  };

  const renderFidCardOrJackpotMatch = () => {
    const numeroClient = user?.fidCard?.[0]?.fidelityInfo?.numeroClient;

    if (numeroClient) return renderJackpotMatch();
    // if (numeroClient) return renderFidCardButtonAdded();

    return renderFidCardButtonNotAdded();
  };

  const renderTotalToPay = () => {
    const isPromo = cartItems.promoPrice < cartItems.itemsPrice;
    const isJackpotMatch = jackpotMatchAmount > 0;
    const totalToPay = calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, jackpotMatchAmount);

    return (
      <>
        {(isPromo || isJackpotMatch) && totalToPay > 0 && (
          <span className="promotion_sliced mr-2">
            {formatPriceWithEuro(cartItems.itemsPrice)}
          </span>
        )}
        {formatPriceWithEuro(totalToPay)}
      </>
    );
  };
  // END Jackpot Match

  return (
    <>
      <BottomSheet
        open
        ref={sheetRef}
        className={clsx("chart-slider rounded-t-[25px] relative z-[1509]",
          { "!opacity-0": currentProduct }
        )}
        onDismiss={onclickExterior}
        scrollLocking={false}
        blocking={showCart}
        defaultSnap={() => 120}
        snapPoints={({ maxHeight }) => [maxHeight * 0.9, 120]}
        onClick={handleResetToaster}
        skipInitialTransition
        expandOnContentDrag={!showCart}
        onSpringStart={(event) => {
          const currentTimestamp = Date.now();
          if (event.type === SNAP && event.source !== DONTLOOP) {
            handleShowCart();
            handleResetToaster();
            console.info('onSpringStart', currentTimestamp - lastCallTimestamp);
            setLastCallTimestamp(currentTimestamp);
          }
        }}
      >
      {store?.item_limit && !showCart ?
        <div className="flex justify-start items-center gap-2 absolute -top-[50px] left-[10px] px-[11px] py-[3px] rounded-full border-[2px] border-[#966C03] bg-[#FFE5A4]">
          <div>
            <IoInformationCircleOutline size={23} stroke="#966C03" fill="#966C03" />
          </div>
          <div className="text-[#966C03] text-xl">
            Maximum {store.item_limit} articles
          </div>
        </div> : null}

        {showCart && (
          <div className="header_footer_cart">
            <div className="flex flex-col">
              <span className="header_footer_cart_text">
                Panier
                {theme?.screenDecorations?.footerCartTitleIcon && (
                  <img
                    src={theme?.screenDecorations?.footerCartTitleIcon?.image}
                    alt="toile3"
                    className="sucette"
                  />
                )}
              </span>

            {store?.item_limit ?
              <small className="text-[15px]">(maximum {store.item_limit} articles)</small>
            : null}

              <span
                className="text-xl color-label open-sans"
                style={{
                  fontFamily: 'Open Sans',
                  color: '#9C9C9C',
                }}
              >
                {countItems > 1
                  ? `${countItems} articles`
                  : `${countItems} article`}
              </span>
            </div>

            <CalculatePromoButton
              store={store}
              cartItems={cartItems}
              axiosInstance={axiosInstance}
              showCart={showCart}
              isCartChanged={cartChange}
              handleCartChange={handleCartChange}
            />
            {theme?.screenDecorations?.footerCartTopDecoration && (
              <img
                src={theme?.screenDecorations?.footerCartTopDecoration?.image}
                alt="toile3"
                className="absolute right-0"
              />
            )}
          </div>
        )}
        {loadingCart && showCart && (
          // A mettre au milieu du panier
          <LoaderWithText type2={true} text="Chargement..." isRounded />
        )}

        <footer
          id="footerPanier"
          className={`footer-container relative bottom-0 rounded-t-[25px] duration-300 bg-white flex flex-col items-center
                    ${showCart ? 'open overflow-auto' : 'h-[8vh] overflow-hidden'}`}
          onClick={onClickInfooter}
          onKeyUp={onClickInfooter}
          onKeyDown={onClickInfooter}
        >
          {showCart ? (
            <>
              {loadingCart ? (
                <>
                  <div
                    className="absolute z-50 w-full h-full "
                    style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}
                  >
                    <div className="z-50 absolute h-full left-2/4 top-[25%]  -translate-x-2/4 ">
                      <div className="lds-spinner white">
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                        <div/>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <>
                {/*<ul className="w-full relative h-full px-6 mb-[150px] flex flex-col">*/}
                <ul className="item-container">
                  {countItems ? (
                    <></>
                  ) : (
                    <div className="absolute transform translate-x-[-50%] translate-y-[-50%] top-[40%] left-[50%]">
                      <img src={paniervide} alt="" />
                    </div>
                  )}

                  {cartItems?.orderItems.map((item, index) => {
                      return (
                        <li key={item.Code_Barre || item._id || index} className="mt-0">
                          <div
                            className="flex items-center justify-between p-2 bg-white cart_list "
                            style={{ borderColor: item.CountInStock }}
                          >
                            <div className="flex items-center justify-center gap-8 overflow-hidden">
                              <img
                                src={item.image}
                                alt={item.image}
                                className="object-contain"
                                style={{ height: '55px', width: '55px' }}
                              />
                              <div className="py-2 ml-4">
                                <div
                                  className="flex flex-col gap-4 text-xl text-left min-30"
                                  style={{ fontFamily: 'Open Sans' }}
                                >
                                  <PromoAndPointsDisplay
                                    item={item}
                                    pikkocoin={pikkocoin}
                                    user={user}
                                  />
                                  <p className="mb-2">
                                    {truncate(item.name, 26)}
                                  </p>
                                  <p className="cart-item-price">
                                    <div>
                                      {item?.promoPrice >= 0 ? (
                                        <>
                                          {formatPriceWithEuro(
                                            item.promoPrice * item.Qty,
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {formatPriceWithEuro(
                                            item.price * item.Qty,
                                          )}
                                        </>
                                      )}

                                      {item.promoPrice && item.price && (
                                        <span className="promotion_sliced">
                                          {formatPriceWithEuro(
                                            item.price * item.Qty,
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </p>
                                </div>
                              </div>
                            </div>
                            {item.price === 0 ? (
                              <></>
                            ) : (
                              <div
                                className="min-30_price rounded-full py-1 grid grid-cols-3 h-[40px] w-[100px]
                                            items-center text-2xl relative justify-between px-4
                                            "
                              >
                                <button
                                  type="button"
                                  className="flex items-center justify-center h-full "
                                  onClick={(event) =>
                                    removeFromCartHandler(event, [
                                      { product: item, qty: 1 },
                                    ])
                                  }
                                >
                                  {item.Qty === 1 ? (
                                    <>
                                      <img
                                        src={cartdelete}
                                        alt="delete"
                                        className="w-auto"
                                      />
                                    </>
                                  ) : (
                                    <img src={moins_icon} alt="" />
                                  )}
                                </button>
                                {localQty[index] ? (
                                  <span className="flex items-center justify-center h-full text-2xl text-center ">
                                    {localQty[index]}
                                  </span>
                                ) : (
                                  <span className="flex items-center justify-center text-center text-[1.7rem] geomanistBold h-full">
                                    {item.Qty}
                                  </span>
                                )}
                                {store && countItems >= store?.item_limit ? (
                                  <></>
                                ) : (
                                  <button
                                    type="button"
                                    className=""
                                    onClick={(event) =>
                                      addToCartHandler(event, item)
                                    }
                                  >
                                    <img src={plus_icon} alt="" />
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </>
            </>
          ) : (
            <></>
          )}
          {showCart && disablePurchaseButton() && (
            <div className="warning-message">{`Panier minimum de ${formatPriceWithEuro(
              MINIMUM_PRICE,
            )}`}</div>
          )}

          {showCart && (
            <div className="price_footer w-full gap-4  text-[1.7rem] geomanistMedium z-200">
              <div className="flex items-center justify-around w-full gap-6 ">
                <div className="flex flex-col items-start w-full open-sans-bold">
                  <span className="color-label text-[16px] open-sans-bold ">
                    Total à payer{' '}
                  </span>
                </div>
                <div className="flex flex-col">
                  <p className="color-label text-[16px] open-sans-bold">
                    {renderTotalToPay()}
                  </p>
                </div>
              </div>
            </div>
          )}

          {isFidelityCardAdded ? renderFidCardOrJackpotMatch() : null}
          {isFidelityCardNotAdded ? renderFidCardButtonNotAdded() : null}

          <div
            className={`purchase-button-container
              ${
                showCart ?
                  disablePurchaseButton() ?
                    'filter grayscale !rounded-[1.5em]' :
                    'payer p-6 pl-100 !rounded-[1.5em] bottom-btn-shadow'
                  :
                  <></>
              }`}
          >
            {showCart ?
              <></> : (
              <div className="flex items-center justify-center w-full">
                <div
                  id="footerCart"
                  className="flex flex-col items-start justify-center w-full geomanistMedium inter"
                >
                  <span className="text-[22px] open-sans-bold">Panier</span>
                  <div
                    className="text-xl  !text-[1.5rem]"
                    style={{
                      fontFamily: 'Open Sans ',
                      color: '#9C9C9C',
                    }}
                  >
                    {countItems > 1
                      ? `${countItems} articles`
                      : `${countItems} article`}
                  </div>
                </div>
                <div className=" text-[22px] open-sans-bold">
                  {formatPriceWithEuro(cartPrice(cartItems))}
                </div>
              </div>
            )}

            <button
              type="button"
              onClick={toPay}
              disabled={disablePurchaseButton() && showCart}
              className={`purchase-button ${
                disablePurchaseButton() && showCart
                  ? 'disabled'
                  : showCart ? ''
                    : 'footer-cart-button bottom-btn-shadow'
              }`}
            >
              <div
                className={
                  showCart
                    ? ' color-label  w-[130px] text-[1.9rem] geomanistMedium'
                    : ' color-label  text-[1.7rem] w-[130px]  geomanistMedium'
                }
              >
                {showCart ? <>Valider/Payer</> : <>Voir mon panier</>}
              </div>
            </button>
          </div>
        </footer>
      </BottomSheet>
    </>
  );
};

export default forwardRef(FooterCart);
